module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_color-photo-55dcc8892e3bef19728ce7b6d3894e98.jpg";